<template>
  <div>
    <!--头部-->
    <div id="fy_header" class="fy_head_title">
      <span>服务热线:</span>
      <span>020-28185798</span>
    </div>
    <!--/头部-->
    <!--导航栏-->
    <div id="fy_navbar" class="navbar navbar-default">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <img class="navbar-brand middle" src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/public/logo.png" alt="logo">
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="fy_navbar_item">
          <ul class="nav navbar-nav middle">
            <li v-for="(item,index) in headTitle">
              <a href="javascript:;" :class="{'title_bold': selectedIndex === index}" @click="goTo(index,item.path)">
                {{item.title}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--/导航栏-->
  </div>
</template>

<script>
  import './../assets/css/fy_header.css'
  import titleList from "../assets/conf/titleList"
  import {mapState} from 'vuex'
    export default {
        name: "fy_header",
        data() {
            return {
                // selectedIndex: 0,
                headTitle: titleList
            }
        },
        computed: {
            ...mapState({
                selectedIndex: state => state.selectedTitle,
            })
        },
        mounted() {
            console.log(this.$cookies.get('selectedTitle'))
            let index = parseInt(this.$cookies.get('selectedTitle') || 0)
            console.log(this.$route.name)
            let path = ['index','software','hardware','service','contact']
            if(this.$route.name === path[index]){
                this.$store.dispatch('chooseTitle',{index: index})
            }
        },
        methods: {
            // 跳转页面
            goTo(index,path) {
                this.$store.dispatch('chooseTitle',{index: index})
                this.$router.push(path)
                this.$cookies.set('selectedTitle',index,'1d','/')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_header.vue